module.exports = __webpack_public_path__ + "media/images/index-feature-bg-9582f8ecc5573fb822e14aea625917e2.svg";